import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from '@laurentgoudet/ngx-cookie';

@Injectable()
export class DOptimistTracking {
  private isEnabled = false;

  constructor(
    private ngZone: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object,
    private route: ActivatedRoute,
    private cookie: CookieService,
  ) {}

  init() {
    if (this.isEnabled || isPlatformServer(this.platformId)) {
      return;
    }
    // Since the pixel is merely an image network request, I'm not confident it
    // has a mechanism to distinguish from other traffic. Other platforms like google
    // and facebook and other vendors have some sort of click id and have internal
    // logic in their JS.
    if (this.route.snapshot.queryParams.utm_source === 'digital_optimist') {
      this.cookie.put('FROM_DOPTIMIST', 'true');
    }
    if (this.cookie.get('FROM_DOPTIMIST') === 'true') {
      this.isEnabled = true;
    }
  }

  trackCustomEvent(countryName: string): void {
    if (!this.isEnabled) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      const offerId = this.getOfferId(countryName);
      if (!offerId) {
        return;
      }
      const trackingUrl = `https://adtracking.d-optimist.com/success.jpg?offer_id=${offerId}&afstatus=1`;

      // previous implementation (sendBeacon) did not work. Likely because it uses POST
      // The instructions of the vendor is to add an image tag like so
      // <img src="https://adtracking.d-optimist.com/success.jpg?offer_id=169&afstatus=1" height="1" width="1" alt="" />
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.alt = '';
      img.src = trackingUrl;
    });
  }

  private getOfferId(countryName: string) {
    switch (countryName) {
      case 'United States':
        return '169';
      case 'United Kingdom':
        return '185';
      case 'New Zealand':
        return '186';
      case 'Australia':
        return '187';
      case 'Canada':
        return '188';
      default:
        return undefined;
    }
  }
}
